<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div class="table-responsive">
    <table class="table table-hover table-sm">
      <thead class="table-light">
        <tr>
          <th>#</th>
          <th>Screen ID</th>
          <th>Name</th>
          <th>Status</th>
          <th>Filler Ad</th>
        </tr>
      </thead>
      <tbody>
        @for (screen of data.screens; track screen; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ screen.screen_id }}</td>
            <td>{{ screen.screen_name }}</td>
            <td [ngClass]="screen.status === 'LIVE' ? 'text-danger' : screen.status === 'Standby' ? 'text-success' : ''">
            {{ screen.status }}</td>
            <td>{{ screen.filler_ad ? 'Yes' : 'No' }}</td>
          </tr>
        }
      </tbody>
    </table>
    @if (!data.screens || data.screens.length === 0) {
      <div class="text-center text-muted" style="margin-top:2rem;">
        No screens to display.
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>